import AutoNumeric from "autonumeric";

angular.module("AccountingBoxApp").directive("abMoney",function ($filter, $locale) {
  // Declare a empty options object
  let options = {
    alwaysAllowDecimalCharacter: true,
    decimalCharacter: ",",
    decimalCharacterAlternative: ".",
    digitGroupSeparator: ".",
    eventBubbles:'false',
    modifyValueOnWheel: 'false'
    // altDec:'.',
    // aDec:',',
    // aSep: '.',
  };
  return {
    // Require ng-model in the element attribute for watching changes.
    require: '?ngModel',
    // This directive only works when used in element's attribute
    restrict: 'A',
    compile: function (tElm, tAttrs) {

      let isTextInput = tElm.is('input:text');

      return function (scope, elm, attrs, controller) {
        // Get instance-specific options.
        let opts = angular.extend({}, options, scope.$eval(attrs.money));
        let element = new AutoNumeric(elm[0], opts);

        // Helper method to update autoNumeric with new value.
        let updateElement = function (element, newVal) {
            element.set(newVal)
        };

        // if element has controller, wire it (only for <input type="text" />)
        if (controller && isTextInput) {
          controller.$parsers.push(function(inputValue) {
            return Number(AutoNumeric.unformat(inputValue,  opts ));
          })
            // watch for external changes to model and re-render element
          scope.$watch(tAttrs.ngModel, function (current, old) {

          });
          // render element as autoNumeric
          controller.$render = function () {
            updateElement(element, controller.$viewValue);
          }
          // Detect changes on element and update model.
          elm.on('change', function (e) {
            scope.$apply(function () {
              controller.$setViewValue(Number(element.get()));
            });
          });
        }
        else {
          // Listen for changes to value changes and re-render element.
          // Useful when binding to a readonly input field.
          if (isTextInput) {
            // attrs.$observe('value', function (val) {
            //   updateElement(elm, val);
            // });
          }
        }
      }
    } // compile
  } // return
});


// angular.module("AccountingBoxApp").directive("money",function ($filter, $locale) {
//   return {
//     restrict: 'A',
//     require: 'ngModel',
//     link: function (scope, el, attr, ctrl) {
//       console.log('el',el[0]);
//
//         let anElement = new AutoNumeric(el[0], {
//           alwaysAllowDecimalCharacter: true,
//           decimalCharacter: ",",
//           decimalCharacterAlternative: ".",
//           digitGroupSeparator: "."
//         });
//
//       // Helper method to update autoNumeric with new value.
//       const updateElement = function (element, newVal) {
//         // Only set value if value is numeric
//         if ($.isNumeric(newVal))
//           element.autoNumeric('set', newVal);
//       };
//
//       if (controller && isTextInput) {
//         // watch for external changes to model and re-render element
//         // scope.$watch(tAttrs.ngModel, function (current, old) {
//         //   controller.$render();
//         // });
//         // render element as autoNumeric
//         controller.$render = function () {
//           updateElement(elm, controller.$viewValue);
//         }
//         // Detect changes on element and update model.
//         el.on('change', function (e) {
//           scope.$apply(function () {
//             controller.$setViewValue(el.autoNumeric('get'));
//           });
//         });
//       }
//
//       // // format on init
//       // formatMoney();
//       //
//       // function formatMoney() {
//       //   var value = ctrl.$modelValue;
//       //
//       //   // remove all separaters first
//       //   var groupsep = $locale.NUMBER_FORMATS.GROUP_SEP;
//       //   var re = new RegExp(groupsep, 'g');
//       //   value = String(value).replace(re, '');
//       //
//       //   // format using angular
//       //   var currencyFilter = $filter('currency');
//       //   var value = currencyFilter(value, "");
//       //
//       //   // sorry but no cents
//       //   var decimalsep = $locale.NUMBER_FORMATS.DECIMAL_SEP;
//       //   value = value.split(decimalsep)[0];
//       //
//       //   // render
//       //   ctrl.$viewValue = value;
//       //   ctrl.$render();
//       // };
//       //
//       // // subscribe on changes
//       // scope.$watch(attr.ngModel, function() {
//       //   formatMoney();
//       // });
//     }
//   };
// });
